import React from "react";

// Groupe de boutons radio pour une échelle générique (valeurs numériques, suffixe optionnel).
export const ScaleQuestion = ({ id, statement, index, labels, value, onChange, optionsGridClass = "grid-cols-1 sm:grid-cols-5", valueSuffix = "" }) => (
  <div
    className="rounded-2xl border border-[var(--border)] bg-white/70 p-4 sm:p-5 transition-shadow hover:shadow-sm print-break"
    data-testid={`question-${id}`}
  >
    <p className="text-[var(--ink)] text-base leading-snug mb-4">
      {index != null && (
        <span className="text-[var(--gold)] font-semibold mr-2">{index}.</span>
      )}
      {statement}
    </p>
    <div className={`grid ${optionsGridClass} gap-2`}>
      {labels.map((opt) => {
        const active = value === opt.value;
        return (
          <label
            key={opt.value}
            data-testid={`option-${id}-${opt.value}`}
            className={`cursor-pointer rounded-xl border px-3 py-2.5 text-center transition-all duration-200 select-none ${
              active
                ? "border-[var(--gold)] bg-[var(--gold)] text-white shadow-sm"
                : "border-[var(--border)] bg-[var(--sand)] text-[var(--ink-soft)] hover:border-[var(--gold-light)]"
            }`}
          >
            <input
              type="radio"
              name={id}
              value={opt.value}
              checked={active}
              onChange={() => onChange(opt.value)}
              className="sr-only"
            />
            <span className={`block text-lg font-semibold ${active ? "text-white" : "text-[var(--gold)]"}`}>
              {opt.value}{valueSuffix}
            </span>
            <span className="block text-[0.68rem] leading-tight mt-0.5">{opt.label}</span>
          </label>
        );
      })}
    </div>
  </div>
);
